import { Link, useParams } from 'react-router-dom';
import { ArrowLeftIcon, PencilIcon } from '@heroicons/react/24/outline';
import Card, { CardHeader, CardBody } from '@/components/ui/Card';
import Button from '@/components/ui/Button';
import Badge from '@/components/ui/Badge';

const mockPublisher = {
  id: 1,
  name: 'Éditions Kampus',
  books: 156,
  published: 142,
  pending: 12,
  failed: 2,
  status: 'active',
  created_at: '2023-06-15',
  config: {
    default_language: 'fr-CA',
    auto_publish: false,
  },
};

export default function DistPublisherDetailPage() {
  const { id: _id } = useParams();

  return (
    <div className="space-y-6 animate-fade-in">
      <Link
        to="/distribution/publishers"
        className="inline-flex items-center gap-2 text-slate-500 hover:text-slate-700"
      >
        <ArrowLeftIcon className="w-4 h-4" />
        Back to Publishers
      </Link>

      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">{mockPublisher.name}</h1>
          <Badge variant="success" className="mt-2">Active</Badge>
        </div>
        <Button variant="outline" leftIcon={<PencilIcon className="w-4 h-4" />}>
          Edit Publisher
        </Button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card><CardBody className="text-center">
          <p className="text-3xl font-bold text-slate-800">{mockPublisher.books}</p>
          <p className="text-sm text-slate-500">Total Books</p>
        </CardBody></Card>
        <Card><CardBody className="text-center">
          <p className="text-3xl font-bold text-success-500">{mockPublisher.published}</p>
          <p className="text-sm text-slate-500">Published</p>
        </CardBody></Card>
        <Card><CardBody className="text-center">
          <p className="text-3xl font-bold text-warning-500">{mockPublisher.pending}</p>
          <p className="text-sm text-slate-500">Pending</p>
        </CardBody></Card>
        <Card><CardBody className="text-center">
          <p className="text-3xl font-bold text-danger-500">{mockPublisher.failed}</p>
          <p className="text-sm text-slate-500">Failed</p>
        </CardBody></Card>
      </div>

      <Card>
        <CardHeader title="Configuration" />
        <CardBody>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm text-slate-500">Default Language</p>
              <p className="font-medium">{mockPublisher.config.default_language}</p>
            </div>
            <div>
              <p className="text-sm text-slate-500">Auto Publish</p>
              <p className="font-medium">{mockPublisher.config.auto_publish ? 'Yes' : 'No'}</p>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

